import { render, staticRenderFns } from "./partnerRecharge.vue?vue&type=template&id=2e78f792&"
import script from "./partnerRecharge.vue?vue&type=script&lang=ts&"
export * from "./partnerRecharge.vue?vue&type=script&lang=ts&"
import style0 from "./partnerRecharge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports